const INIT_COMPANY = [
    {
        name: 'Jobs',
        href: '',
    },
    {
        name: 'Newsroom',
        href: '',
    },
    {
        name: 'Get_Now_Pay Press',
        href: '',
    },
    {
        name: 'Become a Partner',
        href: '',
    },
];

export default INIT_COMPANY;
